import React, { useEffect, useState } from 'react';
import UserReportsList from '../user/UserReportsList';
import api from '../../utils/api';

const UserReports = () => {
  const [users, setUsers] = useState([]);

  // Define refreshUsers function
  const refreshUsers = () => {
    api.get('/reports')
      .then(({ data }) => setUsers(data.data))
      .catch((err) => console.error('Error fetching users:', err));
  };

  useEffect(() => {
    refreshUsers();
  }, []);

  return (
    <div className="container-fluid py-4">
      <h3 className="mb-3">Reported Profiles</h3>
      {/* Pass refreshUsers to UserReportsList */}
      <UserReportsList users={users} refreshUsers={refreshUsers} />
    </div>
  );
};

export default UserReports;